module.exports = __webpack_public_path__ + "img/洛丽碎片.e3b826c8.png";